import { render } from "./IndividualProduct.vue?vue&type=template&id=eb19c340&scoped=true&ts=true"
import script from "./IndividualProduct.vue?vue&type=script&lang=ts"
export * from "./IndividualProduct.vue?vue&type=script&lang=ts"

import "./IndividualProduct.vue?vue&type=style&index=0&id=eb19c340&scoped=true&lang=css"

import exportComponent from "/home/dankoff_shop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb19c340"]])

export default __exports__